export const getMaskedMobileNo = (mobileNumber) => {
  let cleanMobileNo = mobileNumber?.replace(/^0+/, "").replace(/\+/g, "").replace(/\s+/g, "");
  return cleanMobileNo?.slice(0, 3) + " xxx xxx";
};


export const maskMobileNumber = (mobileNumber) => {
  return mobileNumber?.replace(/(\+\d{3})(\d{3})(\d{3})(\d{3})/, "$1 $2 xxx xxx");
};